import { Nullable } from "@/api/ApiClient";
import { WithCustomerInfo } from "./DocumentClientType";
import { WithReferenceCode } from "./ReferenceCodeType";

export interface BuyInvoiceFormCore extends WithReferenceCode<WithCustomerInfo<{
    id: string | undefined,
    numero: number,
    sequence: string,
    invoice_key: string,
    tipo: string,
    nombre_factura: string,
    tel1: string,
    tel1_cd: string,
    tel2: string,
    tel2_cd: string,
    email: string,
    direccion: string,
    clientActivitycode: string,
    fecha: string,
    porcenta_descuento: number,
    subtotal: number,
    descuento: number,
    discountCode: string,
    impuestos: number,
    impuestos_servicio: number,
    total: number,
    anulada: boolean,
    tipo_identificacion: string,
    identificacion: string,
    pagada: boolean,
    status: string,
    saleCondition: number,
    exenta: boolean,
    exchange_rate: number,
    einvoice_status: number,
    edocument_status_payload: string,
    document_comments: string,
    customfields: string,
    info_references: string,
    otros_cargos: string,
    plazo: number,
    activitycode: string,
    province_id: string,
    canton_id: string,
    district_id: string,
    ref_doctype: string,
    ref_numero: string,
    ref_date: string,
    ref_razon: string,
    ref_codigo: string,
    buyInvoiceType: string,
    providerId: string,
    provider: any,
    currencyId: string,
    currency: any,
    providerRecibeId: string,
    buyInvoiceProducts: any[],
    buyInvoicePayments: any[],
    user: string,
}>> { }

export type BuyInvoiceFormData = Nullable<BuyInvoiceFormCore>;
export const buyInvoiceRelatedAttributes: Array<keyof BuyInvoiceFormData> = ["client", "currency", "provider", "buyInvoiceProducts", "buyInvoicePayments"];